/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
  Button,
  Col,
  Row,
} from "reactstrap";

import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import br from "date-fns/locale/pt-BR";
import en from "date-fns/locale/en-US";

import { withTranslation } from "react-i18next";

import "./lightTheme.scss";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const ConversationFilterCardInput = ({ t, ...props }) => {
  registerLocale("br", br);
  registerLocale("en", en);

  const { mainTheme } = useSelector((state) => state.Layout);

  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  const customStyles = {
    multiValue: (styles, { data }) => ({
      ...styles,
      backgroundColor: "#dfe3ec",
    }),
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#2A3042",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#2A3042",
      ":hover": {
        cursor: "pointer",
        backgroundColor: data.color,
        color: "#556ee6",
      },
    }),
  };

  useEffect(() => {
    mainTheme && importDarkMode(mainTheme);
  }, [mainTheme]);

  return (
    <InputGroup className={!props?.noMargin ? "my-2" : ""}>
      <Row className={`${!props?.noMargin ? "mb-2" : ""} mx-0 w-100`}>
        <Col
          md="3"
          className="px-0"
          id={`${props?.filterCardInputTitle}-container`}
        >
          {props.addon && (
            <InputGroupAddon
              id={`${props?.filterCardInputTitle}`}
              className="filter-input-addon"
              addonType="prepend"
            >
              <InputGroupText className="filter-data-append">
                {props.filterCardInputTitle}
              </InputGroupText>
            </InputGroupAddon>
          )}
        </Col>
        <Col md="9" className="px-0">
          {props.dropdown && !props.select && !props.datepicker && (
            <ButtonDropdown
              className="filter-data-input filter-card-input-dropdown"
              isOpen={dropdownOpen}
              toggle={toggle}
              direction="right"
            >
              <DropdownToggle
                className="d-flex justify-content-between align-middle text-nowrap"
                color="#2e3548"
                caret
              >
                {props.filterCardInputPlaceholder}
                <i className="bx bx-chevron-down d-flex align-self-center" />
              </DropdownToggle>
              <DropdownMenu>
                {props.dropdownOptions && props?.dropdownOptions?.length > 0
                  ? props?.dropdownOptions.map((element) => (
                      <DropdownItem>{element}</DropdownItem>
                    ))
                  : []}
              </DropdownMenu>
            </ButtonDropdown>
          )}

          {props.select && !props.dropdown && !props.datepicker && (
            <div className="select-input-filter select2-container">
              <Select
                classNamePrefix="filter-data-input select2-selection"
                styles={customStyles}
                placeholder={props.filterCardInputPlaceholder}
                options={
                  props?.selectOptions &&
                  props?.selectOptions.map((element, key) => ({
                    ...element,
                    key: key,
                  }))
                }
                isMulti={props.isMulti}
                onChange={(e) => {
                  props.onChange(e);
                }}
                value={props.value}
                {...props.save}
              />
            </div>
          )}

          {props.datepicker && !props.dropdown && !props.select && (
            <div className="d-flex" id="datePickerContainer">
              <DatePicker
                calendarClassName="filter-data-date-picker"
                autoComplete="off"
                placeholderText={props.filterCardInputPlaceholder}
                selected={props.value[0]}
                onChange={props.onChange}
                startDate={props.value[0]}
                endDate={props.value[1]}
                selectsRange={true}
                inline
                locale={t("en")}
              />
              <div className="w-100">
                <Button
                  id="cleardatepicker"
                  className="filter-data-prepend input-group-text"
                  onClick={props.onClearDatePicker}
                >
                  {t("Clear")}
                </Button>
              </div>
            </div>
          )}

          {!props.select && !props.dropdown && !props.datepicker && (
            <Input
              className="filter-data-input"
              placeholder={props.filterCardInputPlaceholder}
              onChange={props.onChange}
              defaultValue={props.defaultValue}
              value={props.value}
            />
          )}
        </Col>
      </Row>
    </InputGroup>
  );
};

export default withTranslation()(ConversationFilterCardInput);
